import { render, staticRenderFns } from "./VendorListing.vue?vue&type=template&id=b6d2a62e&"
import script from "./VendorListing.vue?vue&type=script&lang=js&"
export * from "./VendorListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports